import React, { useEffect, useState } from 'react';
import Filter from './Filter';
import FilterRange from './FilterRange';

const FilterGroup = ({
  label,
  id,
  handleFilter,
  handleSlider,
  type,
  query,
}) => {
  const [isActive, setActive] = useState(false);
  const [isTruncated, setIsTruncated] = useState(true);

  const toggleShowMore = () => {
    if (isTruncated) {
      setIsTruncated(false);
    } else {
      setIsTruncated(true);
    }
  };

  const toggleClose = () => {
    setActive(false);
  };

  const toggleOpen = () => {
    setActive(true);
  };

  const toggleOpenClose = (e) => {
    // React wants a keyboard listener since there is an onclick. Need to make sure it's a specific key.
    if (e.type === 'keydown' && e.code !== 'Enter') {
      return;
    }

    if (isActive) {
      setActive(false);
    } else {
      setActive(true);
    }
  };

  return (
    <div className={isActive ? 'active' : 'inactive'}>
      <div className="filter-group-header">
        <div
          className="filter-group-header--label"
          role="button"
          tabIndex="0"
          onClick={toggleOpenClose}
          onKeyDown={toggleOpenClose}
        >
          {label}
        </div>
        <div
          role="button"
          tabIndex="0"
          onClick={toggleClose}
          onKeyDown={toggleClose}
          className="closer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            viewBox="0 0 448 512"
          >
            <path d="M432 256C432 264.8 424.8 272 416 272H32c-8.844 0-16-7.15-16-15.99C16 247.2 23.16 240 32 240h384C424.8 240 432 247.2 432 256z" />
          </svg>
        </div>
        <div
          role="button"
          tabIndex="0"
          onClick={toggleOpen}
          onKeyDown={toggleOpen}
          className="opener"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            viewBox="0 0 448 512"
          >
            <path d="M432 256C432 264.8 424.8 272 416 272h-176V448c0 8.844-7.156 16.01-16 16.01S208 456.8 208 448V272H32c-8.844 0-16-7.15-16-15.99C16 247.2 23.16 240 32 240h176V64c0-8.844 7.156-15.99 16-15.99S240 55.16 240 64v176H416C424.8 240 432 247.2 432 256z" />
          </svg>
        </div>
      </div>
      <div className="filter-group-content">
        <div
          className={
            Object.keys(id.value).length > 8 && isTruncated
              ? 'active'
              : 'inactive'
          }
        >
          <Filter
            type={type}
            data={id}
            query={query}
            handleFilter={handleFilter}
            handleSlider={handleSlider}
          />
        </div>
        {type !== 'number' && Object.keys(id.value).length > 8 && (
          <span
            role="button"
            tabIndex="0"
            onClick={toggleShowMore}
            onKeyDown={toggleShowMore}
            className="truncator"
          >
            {isTruncated
              ? `Show ${Object.keys(id.value).length - 8} More`
              : 'Show Less'}
          </span>
        )}
      </div>
    </div>
  );
};

export default FilterGroup;
